export const errorMessage = 'Using a corporate account?';
export const linkMessage = 'Continue with corporate email';
export const myChaosPersonalInfo = `${window.CUSTOMER_PORTAL}/account/personal-information`;
